import { createContext } from "react";

import type { ConfigSnapshot, ConfigUser } from "@/helpers/config";

export type ConfigContextValue = { snapshot: ConfigSnapshot; user?: ConfigUser };

export const ConfigContext = createContext<ConfigContextValue | null>(null);
